export default "__VITE_ASSET__a8ebb1b3__"